/**
 * Applicant view storage: which collapsible overview sections (application history, the
 * application's information, …) the user last left open or closed.
 *
 * Keyed by user id, because `auth_purge` clears only the per-tab scope on a sign-in change -- a
 * bare map in localStorage would carry one person's choices over to the next on a shared browser.
 */
import Storage from '../index';
import StorageKeys from '../keys';

const readExpandedByUser = () => Storage.get(StorageKeys.applicantViewSectionsExpanded, {}) || {};

const applicantView = {
    /**
     * Return the remembered state of a section: `true` / `false`, or `null` when the user has
     * never toggled it (or there is no user), so the caller decides the default.
     */
    getSectionExpanded: (userId, sectionId) => {
        if (!userId) return null;
        const expanded = (readExpandedByUser()[userId] || {})[sectionId];
        return typeof expanded === 'boolean' ? expanded : null;
    },

    setSectionExpanded: (userId, sectionId, expanded) => {
        if (!userId) return false;
        const expandedByUser = readExpandedByUser();
        return Storage.set(StorageKeys.applicantViewSectionsExpanded, {
            ...expandedByUser,
            [userId]: { ...(expandedByUser[userId] || {}), [sectionId]: Boolean(expanded) },
        });
    },
};

export default applicantView;
